/**
 * Shared frontend constants.
 *
 * Keeps API_URL and the SOC 2 status-colour palette in a single
 * importable location so they don't drift across components.
 */

export const API_URL = (process.env.REACT_APP_BACKEND_URL || '').replace(/\/$/, '');

export const STATUS_COLORS = {
  passing: '#059669',
  failing: '#dc2626',
  warning: '#d97706',
  not_implemented: '#6b7280',
  not_applicable: '#9ca3af',
  manual_review: '#7c3aed',
};
